<template>
  <div class="flex justify-center items-center mt-4 mb-4">
    <aha-antd-button
      :underline="true"
      :submitting="isLoadingDismissAll"
      variant="text-link"
      @click="dismissAllMisspellsAction()"
    >
      <span>{{ $i18nPresenter.t('Dismiss all') }}</span>
    </aha-antd-button>
  </div>
</template>
<script >
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('spellchecker', ['isLoadingDismissAll']),
  },
  methods: {
    ...mapActions('spellchecker', ['dismissAllMisspellsAction']),
  },
}
</script>
